export default "__VITE_ASSET__Dx52CGM___"